var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.insight)?_c('insight-factory',{attrs:{"insight":_vm.insight}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }